import { Search } from 'lucide-react';
import type { AssetStatus, ListAssetsParams } from '../api';
import { STATUS_LABELS } from './AtivoStatusBadge';
import { useCategorias, useLocations } from '../hooks';
import { TextInput } from '../../../shared/components/TextInput';
import { AutocompleteSelect } from '../../../shared/components/AutocompleteSelect';

interface Props {
  filters: ListAssetsParams;
  onChange: (patch: Partial<ListAssetsParams>) => void;
  onReset: () => void;
}

const STATUSES: AssetStatus[] = ['in_use', 'available', 'in_maintenance', 'on_loan', 'retired', 'not_found'];

export function AtivoFilters({ filters, onChange, onReset }: Props) {
  const categoriasQuery = useCategorias();
  const locationsQuery = useLocations();

  const statusOptions = [
    { value: '', label: 'Todas' },
    ...STATUSES.map((s) => ({ value: s, label: STATUS_LABELS[s] })),
  ];

  const categoriaOptions = [
    { value: '', label: 'Todas' },
    ...(categoriasQuery.data?.groups.flatMap((g) =>
      g.items.map((i) => ({ value: i.id, label: i.name })),
    ) ?? []),
  ];

  const locationOptions = [
    { value: '', label: 'Todas' },
    ...(locationsQuery.data?.data.map((l) => ({ value: l.id, label: l.name })) ?? []),
  ];

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex flex-wrap items-end gap-3">
        <div className="flex-1 min-w-[220px]">
          <TextInput
            label="Buscar"
            type="text"
            icon={<Search className="h-4 w-4" />}
            value={filters.search ?? ''}
            onChange={(e) => onChange({ search: e.target.value || undefined })}
          />
        </div>

        <div className="min-w-[160px]">
          <AutocompleteSelect
            label="Situação"
            options={statusOptions}
            value={filters.status ?? ''}
            onChange={(v) => onChange({ status: (v || undefined) as AssetStatus | undefined })}
          />
        </div>

        <div className="min-w-[180px]">
          <AutocompleteSelect
            label="Categoria"
            options={categoriaOptions}
            value={filters.categoryId ?? ''}
            onChange={(v) => onChange({ categoryId: v || undefined })}
          />
        </div>

        <div className="min-w-[180px]">
          <AutocompleteSelect
            label="Localização do Ativo"
            options={locationOptions}
            value={filters.locationId ?? ''}
            onChange={(v) => onChange({ locationId: v || undefined })}
          />
        </div>

        <div className="min-w-[180px]" title="Cadastro de responsáveis disponível na SPEC 02">
          <AutocompleteSelect
            label="Responsável"
            options={[{ value: '', label: 'Disponível na SPEC 02' }]}
            value={filters.custodianId ?? ''}
            onChange={(v) => onChange({ custodianId: v || undefined })}
            disabled
          />
        </div>

        <button
          type="button"
          onClick={onReset}
          className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
        >
          Limpar filtros
        </button>
      </div>
    </div>
  );
}
